<template lang="pug">
header
  nav
    .nav_top_bar
      img(src="@/assets/img/media/nav_top_bar_text.png", alt="新安東京海上產險")
    .nav_main.d-flex
      router-link(tag="a", :to="{ name: 'Home' }")
        media-img.logo(:imgUrl="'logo'", alt="新安東京海上產險")

      links.lg
      custom-menu(@menuExpand="menuExpand", :isMoreExpand="isMoreExpand")

    .links_wrapper_sm.sm.d-md-none.i_pl_per_1.i_pr_per_1
      links
    more.fade(
      @menuExpand="menuExpand",
      v-show="isMoreExpand",
      @footerProductClick="footerProductClick"
    )
</template>

<script>
import { stopScroll, startScroll } from "@/utils/scroll";
import "@/assets/style/main.scss";
import Links from "@/components/common/Navigation/Links";
import MediaImg from "@/components/common/MediaImg";
import CustomMenu from "@/components/common/Navigation/Menu";
import More from "@/components/common/Navigation/More";

export default {
  components: {
    links: Links,
    "media-img": MediaImg,
    "custom-menu": CustomMenu,
    more: More,
  },
  data() {
    return {
      fullWidth: 0,
      isMoreExpand: false,
    };
  },
  methods: {
    logoClick() {
      this.$router.push({ name: "Home" });
    },
    menuExpand(active) {
      this.isMoreExpand = active;
      this.isMoreExpand ? stopScroll() : startScroll();
    },
    footerProductClick() {
      this.$emit("footerProductClick");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/navigation";
</style>
